import Config from "../../js/global/Config"

const componentslist = document.querySelectorAll(".bb-feedback")

class FeedbackComponent {
	constructor(HTMLElement) {
		// eslint-disable-next-line no-console
		console.log("FeedbackComponent::initialize()")

		this.cInstanceComponent = HTMLElement
		this._init(this.cInstanceComponent)
	}

	_init(component) {
		component.feedbackForm = component.querySelector("form.form")
		component.submitButton = component.feedbackForm.querySelector("button.form__submit")
		component.inputfield = component.feedbackForm.querySelector("input")

		component.starsParent = component.querySelector(".bb-feedback__stars > .wrapper")
		component.starsList = component.starsParent.querySelectorAll(".bb-feedback__star-button")

		component.initialContent = component.querySelector(".bb-feedback__content")
		component.thankyouContent = component.querySelector(".bb-feedback__thankyou")

		if (this.getFromLS("fComp")) {
			let lsComp = this.getFromLS("fComp")
			if (lsComp[component.dataset.ratingrecipeuid]) {
				for (let star of component.starsList) {
					star.disabled = true

					if (star.dataset.rate > lsComp[component.dataset.ratingrecipeuid]) {
						star.classList.remove("active")
					} else {
						star.classList.add("active")
					}
				}
				component.submitButton.disabled = true
				component.submitButton.parentElement.style.display = "none"
				component.initialContent.style.display = "none"
				component.thankyouContent.style.display = "block"
			}
		}

		this._initEvents(component)
	}

	_initEvents(component) {
		component.starsParent.addEventListener("click", () => {
			let clickedElement = event.target.closest(".bb-feedback__star-button")
			if (event.target.classList.contains("wrapper") || clickedElement.disabled) return
			$(component.submitButton.parentElement).slideDown()

			let found = false
			let value
			for (let item of component.starsList) {
				if (found) {
					item.classList.remove("active")
				} else {
					item.classList.add("active")
				}

				if (clickedElement === item) {
					component.inputfield.value = item.dataset.rate
					value = item.dataset.rate
					found = true
				}
			}

			this._doForSiblings((cmp) => {
				for (let star of cmp.starsList) {
					if (star.dataset.rate > value) {
						star.classList.remove("active")
					} else {
						star.classList.add("active")
					}
				}
				cmp.inputfield.value = value
				$(cmp.submitButton.parentElement).slideDown()
			})
		})

		component.feedbackForm.addEventListener("submit", () => {
			event.preventDefault()

			if (!component.inputfield.validity.valid) return
			for (let item of component.starsList) {
				item.disabled = true
			}

			const dataset = component.dataset
			const url =
				dataset.ratingurl +
				"?action=" +
				dataset.ratingaction +
				"&recipeUid=" +
				dataset.ratingrecipeuid +
				"&favoriteStar=" +
				component.inputfield.value

			component.submitButton.disabled = true

			this.sendRequest(url).then(() => {
				$(component.submitButton.parentElement).slideUp()
				$(component.initialContent).slideUp(() => {
					$(component.thankyouContent).slideDown()
				})

				component.classList.add("py-64")

				let lsComp = this.getFromLS("fComp")
				if (!(typeof lsComp === "object" && lsComp !== null)) lsComp = {}

				lsComp[dataset.ratingrecipeuid] = component.inputfield.value

				this.setToLS("fComp", lsComp)

				this._doForSiblings((cmp) => {
					for (let star of cmp.starsList) {
						star.disabled = true
					}
					cmp.submitButton.disabled = true
					cmp.submitButton.parentElement.style.display = "none"
					cmp.initialContent.style.display = "none"
					cmp.thankyouContent.style.display = "block"
				})
			})
		})
	}

	_doForSiblings(func) {
		for (let cmp of componentslist) {
			if (cmp === this.cInstanceComponent) continue
			func(cmp)
		}
	}

	async sendRequest(url) {
		const response = await fetch((Config.debug && Config.proxy ? Config.proxy : "") + url)
		return response.json()
	}

	getFromLS(keyName) {
		return JSON.parse(localStorage.getItem(keyName))
	}
	setToLS(keyName, object) {
		localStorage.setItem(keyName, JSON.stringify(object))
	}
}

export default FeedbackComponent
